<template>
  <div class="page-wrapper">
    <div class="page-title">
      <CIcon name="cil-info" /> About & Contact
    </div>
    <CRow>
      <CCol md="8" class="mx-auto">
        <CCard>
          <CCardHeader>
            <h4 class="card-title mb-0">Contact Us</h4>
          </CCardHeader>
          <CCardBody class="text-center py-5">
            <div class="mb-4">
              <span class="contact-icon">
                <CIcon name="cil-envelope-open" />
              </span>
            </div>
            <h5 class="mb-3">Get in Touch</h5>
            <p class="lead text-muted mb-4" style="max-width: 460px; margin: 0 auto;">
              For any kinds of queries, suggestions, modifications or contributions to the development of our system, you can write to:
            </p>
            <a href="mailto:info@strofes.com" class="contact-email">
              <CIcon name="cil-envelope-closed" /> info@strofes.com
            </a>
          </CCardBody>
          <CCardFooter class="text-center">
            <small class="text-muted">Save Animals &mdash; Wildlife Rescue Management System</small>
          </CCardFooter>
        </CCard>
      </CCol>
    </CRow>    
  </div>
</template>

<script>
export default {
  name: 'About'
}
</script>
